import { GameContext } from '../../../../contexts/GameContext';
import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import { ZdarKidsGameStepConfiguration } from '../../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import ContinueButton from '../../../common/buttons/ContinueButton';
import React, { useContext, useEffect, useState } from 'react';
import bg from '../../../../assets/images/games/zdar-kids-game/pond/bg.webp';
import blue from '../../../../assets/images/games/zdar-kids-game/pond/blue.webp';
import can from '../../../../assets/images/games/zdar-kids-game/pond/can2.webp';
import car from '../../../../assets/images/games/zdar-kids-game/pond/car.webp';
import carp from '../../../../assets/images/games/zdar-kids-game/pond/carp.webp';
import final from '../../../../assets/images/games/zdar-kids-game/pond/final.webp';
import fish1 from '../../../../assets/images/games/zdar-kids-game/pond/fish1.webp';
import fish2 from '../../../../assets/images/games/zdar-kids-game/pond/fish2.webp';
import frog from '../../../../assets/images/games/zdar-kids-game/pond/frog.webp';
import grass1 from '../../../../assets/images/games/zdar-kids-game/pond/grass1.webp';
import grass1Back from '../../../../assets/images/games/zdar-kids-game/pond/grass22.webp';
import grass2 from '../../../../assets/images/games/zdar-kids-game/pond/grass2.webp';
import kaufland from '../../../../assets/images/games/zdar-kids-game/pond/kaufland.webp';
import lobster from '../../../../assets/images/games/zdar-kids-game/pond/lobster.webp';

type Props = {
    onSuccess: () => void;
};
export default function ZdarFairyTaleCharactersCipher({ onSuccess }: Props) {
    const { stepContent } = useContext(GameContext);
    const [solved, setSolved] = useState(false);
    const [showingCar, setShowingCar] = useState(true);
    const [showingCan, setShowingCan] = useState(true);
    const [showingBag, setShowingBag] = useState(true);

    const { continueButtonText } = stepContent as ZdarKidsGameStepConfiguration;

    useEffect(() => {
        if (!showingCan && !showingCar && !showingBag) {
            setSolved(true);
        }
    }, [showingBag, showingCar, showingCan]);

    const onClickBag = () => {
        setShowingBag(false);
    };

    const onClickCar = () => {
        setShowingCar(false);
    };

    const onClickCan = () => {
        setShowingCan(false);
    };

    return (
        <React.Fragment>
            <div className="zdar-kids-cipher__pond">
                <div className={solved ? 'cipher-image' : 'cipher-image hidden'}>
                    <ImageWrapper src={final} alt="background" shouldScroll={true} allowLightbox={false} />
                </div>
                {!solved && (
                    <div className="cipher-image">
                        <ImageWrapper src={bg} alt="background" shouldScroll={false} allowLightbox={false} />
                        {showingBag && (
                            <ImageWrapper
                                onClick={onClickBag}
                                src={kaufland}
                                alt="kaufland"
                                allowLightbox={false}
                                style={{ position: 'absolute', top: '120px', right: '40px', width: '85px' }}
                            />
                        )}
                        <ImageWrapper
                            src={carp}
                            alt="carp"
                            allowLightbox={false}
                            style={{ position: 'absolute', top: '140px', left: '22px', width: '110px' }}
                        />
                        {showingCar && (
                            <ImageWrapper
                                onClick={onClickCar}
                                src={car}
                                alt="car"
                                allowLightbox={false}
                                style={{ position: 'absolute', top: '20px', left: '130px', width: '105px' }}
                            />
                        )}
                        <ImageWrapper
                            src={frog}
                            alt="frog"
                            allowLightbox={false}
                            style={{ position: 'absolute', top: '10px', right: '-5px', width: '60px' }}
                        />
                        <ImageWrapper
                            src={blue}
                            alt="blue"
                            allowLightbox={false}
                            style={{ position: 'absolute', bottom: '40px', right: '10px', width: '120px' }}
                        />
                        <ImageWrapper
                            src={fish1}
                            alt="fish1"
                            allowLightbox={false}
                            style={{ position: 'absolute', bottom: '200px', left: '130px', width: '150px' }}
                        />
                        <ImageWrapper
                            src={fish2}
                            alt="fish2"
                            allowLightbox={false}
                            style={{ position: 'absolute', bottom: '160px', left: '180px', width: '100px' }}
                        />
                        <ImageWrapper
                            src={lobster}
                            alt="lobster"
                            allowLightbox={false}
                            style={{ position: 'absolute', top: '270px', left: '20px', width: '105px' }}
                        />
                        {showingCan && (
                            <ImageWrapper
                                onClick={onClickCan}
                                src={can}
                                alt="can"
                                allowLightbox={false}
                                style={{
                                    position: 'absolute',
                                    bottom: '73px',
                                    left: '123px',
                                    width: '83px',
                                    zIndex: '10',
                                }}
                            />
                        )}
                        {showingCan && (
                            <ImageWrapper
                                src={grass1Back}
                                alt="grass1"
                                allowLightbox={false}
                                style={{ position: 'absolute', bottom: '-10px', left: '-30px', width: '250px' }}
                            />
                        )}
                        <ImageWrapper
                            src={grass1}
                            alt="grass1"
                            allowLightbox={false}
                            style={{ position: 'absolute', bottom: '-10px', left: '-30px', width: '250px' }}
                        />
                        <ImageWrapper
                            src={grass2}
                            alt="grass2"
                            allowLightbox={false}
                            style={{ position: 'absolute', bottom: '-8px', right: '0px', width: '220px' }}
                        />
                    </div>
                )}
                {solved && (
                    <>
                        <div className="zdar-kids-cipher__fairytales__solved">Rybník je vyčištěný!</div>
                        {continueButtonText && <ContinueButton text={continueButtonText} onClick={onSuccess} />}
                    </>
                )}
            </div>
        </React.Fragment>
    );
}
